import { ADMIN_DELETE_COMPANY_USER } from "$mutations";
import { IMutationOptions, useMutation } from "$hooks";

export const useAdminDeleteCompanyUser = () => {
  const { mutation, ...result } = useMutation<IUseAdminDeleteCompanyUser, IResponseProps>(
    ADMIN_DELETE_COMPANY_USER
  );

  const adminDeleteCompanyUser = ({
    variables,
    ...options
  }: IMutationOptions<IResponseProps, IUseAdminDeleteCompanyUser>) =>
    mutation({
      variables,
      ...options,
      update: cache => cache.evict({ id: `CompanyUser:${variables?.uuid}` })
    });

  return { adminDeleteCompanyUser, ...result };
};

interface IResponseProps {
  deleteCompanyUser: number;
}

export interface IUseAdminDeleteCompanyUser {
  uuid: string;
  companyUuid: string;
}
